import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "w-calendar-screen",
  "aria-label": "Календарь приёма"
}
const _hoisted_2 = { class: "w-patient-context" }
const _hoisted_3 = { class: "w-branch-calendar-note" }
const _hoisted_4 = {
  class: "w-legend",
  "aria-label": "Занятость кабинета"
}
const _hoisted_5 = { class: "w-directory" }

import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import { formatDate, hoursText } from '~utils/calendarModel';
import CalendarToolbar from './CalendarToolbar.vue';
import ScheduleBuilder from './ScheduleBuilder.vue';
import SlotSelection from './SlotSelection.vue';
import WeekGrid from './WeekGrid.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarScreen',
  setup(__props) {

const LEGEND = [
  { color: 'green', text: 'Свободен для вас' },
  { color: 'yellow', text: 'Запланирован коллегами' },
  { color: 'red', text: 'Есть пациент' },
  { color: 'gray', text: 'Перерыв или приём закрыт' },
];

const store = useScheduleStore();

const patientText = computed(() => (
  store.patientId
    ? `Для записи выбран пациент №${store.patientId}`
    : 'Пациент не выбран. Выберите пациента на основной странице.'
));

const branchNote = computed(() => {
  const branch = store.currentBranch;
  const day = store.branchDay(store.date);
  const hours = day.open.length
    ? `работа ${hoursText(day.open)} · приём ${hoursText(day.intake)}`
    : 'филиал закрыт';
  return [
    branch?.name,
    formatDate(store.date, { day: 'numeric', month: 'long' }),
    hours,
    day.isException && day.label,
    branch?.timeZone || 'время филиала',
  ].filter(Boolean).join(' · ');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CalendarToolbar),
    (_unref(store).builderOpen)
      ? (_openBlock(), _createBlock(ScheduleBuilder, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(patientText.value), 1),
    _createVNode(SlotSelection),
    _createElementVNode("div", _hoisted_3, _toDisplayString(branchNote.value), 1),
    _createVNode(WeekGrid),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LEGEND, (item) => {
        return _createElementVNode("span", {
          key: item.color,
          class: "w-legend-item"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["w-swatch", item.color])
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(item.text), 1)
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "w-directory-label" }, "Кабинеты", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).allowedRooms, (room) => {
        return (_openBlock(), _createElementBlock("span", {
          key: room.id
        }, [
          _createElementVNode("strong", null, _toDisplayString(room.number ?? room.id), 1),
          _createTextVNode(_toDisplayString(room.purpose || room.name), 1)
        ]))
      }), 128)),
      _createElementVNode("span", null, _toDisplayString(_unref(store).currentBranch?.name), 1)
    ])
  ]))
}
}

})